function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "gear");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  id: "gear_2",
  "data-name": "gear 2",
  d: "M14.42,8.4,13.7,8l.72-.38a2,2,0,0,0,.73-2.73l-1-1.74a2,2,0,0,0-2.74-.74h0l-.72.42,0-.82a2,2,0,0,0-2-2h-2a2,2,0,0,0-2,2v.83L4,2.4a2,2,0,0,0-2.74.73h0l-1,1.74A2,2,0,0,0,1,7.6L1.71,8,1,8.4a2,2,0,0,0-.73,2.73l1,1.74A2,2,0,0,0,4,13.6H4l.72-.42,0,.81a2,2,0,0,0,2,2h2a2,2,0,0,0,2-2v-.83l.7.43a2,2,0,0,0,2.74-.74l1-1.74A2,2,0,0,0,14.42,8.4ZM12.69,9.71l.72.42-1,1.74-.72-.42a2,2,0,0,0-2,0l0,0a2,2,0,0,0-1,1.7V14h-2v-.83a2,2,0,0,0-1-1.7l0,0a2,2,0,0,0-2,0L3,11.87,2,10.13l.7-.41a2,2,0,0,0,0-3.44L2,5.87,3,4.13l.72.42a2,2,0,0,0,2,0l0,0a2,2,0,0,0,1-1.7V2h2v.83a2,2,0,0,0,1,1.7l0,0a2,2,0,0,0,2,0l.72-.42,1,1.74-.72.42a2,2,0,0,0-1,1.7V8a2,2,0,0,0,1,1.71ZM7.71,6a2,2,0,1,0,2,2A2,2,0,0,0,7.71,6Z"
})));

var SvgGear = function SvgGear(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15.42 16",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGear, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gear.6f1afe7a.svg";
export { ForwardRef as ReactComponent };